import React from 'react';
import { SheetSpecItem } from './types';

interface PropertySpecsTableProps {
  specs: SheetSpecItem[];
}

export const PropertySpecsTable: React.FC<PropertySpecsTableProps> = ({ specs }) => {
  return (
    <div className="w-full bg-white rounded-2xl border border-slate-200/90 overflow-hidden shadow-2xs">
      {/* Dark Navy Header */}
      <div className="bg-[#0a2540] px-3.5 py-2">
        <h3 className="text-xs font-black tracking-wider text-white uppercase">
          Ficha de Especificaciones
        </h3>
      </div>

      {/* Rows */}
      <div className="divide-y divide-slate-100">
        {specs.map((item, idx) => (
          <div
            key={idx}
            className="flex items-center justify-between px-3.5 py-1.5 text-xs hover:bg-slate-50/50 transition-colors"
          >
            <span className="text-slate-500 font-medium text-[11px] leading-normal">{item.label}</span>
            <span
              className={`text-right font-bold max-w-[65%] text-[11px] leading-normal ${
                item.highlightGreen ? 'text-emerald-600' : 'text-slate-900'
              }`}
            >
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
